import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-visa.png'


const _withScopeId = n => (_pushScopeId("data-v-9248ace4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-payment-information" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " Payment information ", -1))
const _hoisted_3 = {
  key: 0,
  class: "current-info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no" }, "xxxxx", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "box-list"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = { class: "no" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" + Add New Card ")

import { ref, reactive } from 'vue';
  import { ColorVariants } from '@/constants';

  interface IProps {
    readonly?: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    readonly: { type: Boolean }
  },
  setup(__props: any) {

  
  const dialogVisible = ref(false);
  const cardForm = ref({});
    const checkedId = ref<number>();

  const cards = reactive([
    {
      id: 1,
      no: 'xxx'
    },
    {
      id: 2,
      no: 'xxx'
    }
  ]);

  function handleFormChange(data: any) {
    cardForm[data.key] = data.value;
  }

  function handleSaveAddress() {
    dialogVisible.value = false;
  }

  function handleAdd() {
    cardForm.value = {};
    dialogVisible.value = true;
  }

  function handleCheck(id: number) {
    checkedId.value = id;
  }


return (_ctx: any,_cache: any) => {
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AppRadio = _resolveComponent("AppRadio")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppDialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      title: "Add New Card",
      btns: [
      { text: 'Close', style: _unref(ColorVariants).outlinePrimary, click: () => dialogVisible.value = false },
      { text: 'Save', style: _unref(ColorVariants).primary, click: () => handleSaveAddress() }
    ]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form, { class: "card-form" }, {
          default: _withCtx(() => [
            _createVNode(_component_AppFormGroupItem, {
              config: {
          label: 'First Name',
          type: 'input',
          key: 'first_name',
          required: true,
        },
              form: cardForm.value,
              onChange: handleFormChange
            }, null, 8, ["form"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (__props.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "card-payment"
              }, [
                _createVNode(_component_AppRadio, {
                  "model-value": checkedId.value === item.id,
                  "onUpdate:modelValue": ($event: any) => (handleCheck(item.id))
                }, null, 8, ["model-value", "onUpdate:modelValue"]),
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(item.no), 1)
              ]))
            }), 128)),
            _createVNode(_component_b_button, {
              class: "button-add",
              variant: _unref(ColorVariants).outlinePrimary,
              pill: "",
              onClick: handleAdd
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["variant"])
          ]))
    ])
  ], 64))
}
}

})